<template>
  <span v-show="procedeMostrar">
    <!-- <h4>{{dc.nombre}}</h4> -->
    <!-- <h5>{{dc}}</h5> -->
    <!-- <h5>{{datosRegistro[dc.nombre]}}</h5> -->
    <!-- <h5>{{itemsSelect}}</h5> -->

    <div v-if="!validacionCampo(valorCampo) && !(dc.seleccion_multiple && itemsSelectFiltrado.length == 0)"
      style="float: left; margin-left: -8px; margin-top: 12px; width: 2px; height: 11px; background: red"
    ></div>

    <!-- INTERRUPTOR: campo booleano, sí/no -->
    <v-switch
      v-if="dc.control == 'switch'"
      :ref="dc.nombre"
      :label="labelCampo"
      :false-value="0"
      :true-value="1"
      dense
      inset
      :color="colorCampo"
      class="mt-n1"
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
    ></v-switch>

    <!-- LISTA: campo de tipo array JSON -->
    <template v-else-if="dc.seleccion_multiple">
      <div v-if="itemsSelectFiltrado.length > 0" class="mt-n2 mb-6">
        <template v-if="dc.control != 'lista-etiquetas'">
          <v-icon v-if="dc.icono" class="mr-2">{{dc.icono}}</v-icon>
          <span class="text-caption">{{labelCampo}}</span>
        </template>
        <!-- lista de valores (cuadros de texto) -->
        <template v-if="dc.control == 'lista-valores'">
          <v-text-field
            v-for="elemento in itemsSelectFiltrado"
            :key="elemento.value"
            :label="elemento.text"
            v-model="datosRegistro[dc.nombre][elemento.value]"
            class="mt-3"
            filled
            rounded
            dense
            v-bind="$attrs"
            hide-details
            :rules="[validacionCampo]"
          ></v-text-field>
        </template>
        <!-- lista de etiquetas (combobox + chips) -->
        <template v-else-if="dc.control == 'lista-etiquetas'">
          <v-autocomplete
            v-model="datosRegistro[dc.nombre]"
            :label="labelCampo"
            :items="itemsSelectFiltrado"
            :color="colorCampo"
            :rules="[validacionCampo]"
            :clearable="!dc.requerido && !$attrs.readonly"
            class="mt-n3"
            multiple
            small-chips
            hide-details
            v-bind="$attrs"
            @change="$emit('change', $event, datosRegistro, definicionCampos)"
          ></v-autocomplete>
        </template>
        <!-- lista de selección (casillas de verificación) -->
        <template v-else>
          <v-checkbox
            class="mt-0"
            v-for="elemento in itemsSelectFiltrado"
            v-model="datosRegistro[dc.nombre]"
            :key="elemento.value"
            :value="elemento.value"
            :label="elemento.text"
            :color="colorCampo"
            v-bind="$attrs"
            hide-details
          >{{elemento}}</v-checkbox>
        </template>
      </div>
    </template>

    <template v-else-if="dc.dominio_valores">
      <!-- AUTOCOMPLETE (SELECT con cuadro de búsqueda) -->
      <v-autocomplete
        v-if="dc.control == 'autocomplete'"
        :ref="dc.nombre"
        :label="labelCampo"
        :color="colorCampo"
        :rules="[validacionCampo]"
        :items="itemsSelectFiltrado"
        :clearable="!dc.requerido && !$attrs.readonly"
        dense
        v-model="datosRegistro[dc.nombre]"
        v-bind="$attrs"
        @change="$emit('change', $event, datosRegistro, definicionCampos)"
      ></v-autocomplete>
      <!-- SELECT -->
      <v-select
        v-else
        :ref="dc.nombre"
        :label="labelCampo"
        :color="colorCampo"
        :rules="[validacionCampo]"
        :items="itemsSelectFiltrado"
        :clearable="!dc.requerido"
        :prepend-inner-icon="prependInnerIconCampo"
        dense
        v-model="datosRegistro[dc.nombre]"
        v-bind="$attrs"
        @change="$emit('change', $event, datosRegistro, definicionCampos)"
      ></v-select>
    </template>

    <!-- TEXTAREA: campo de texto multi-linea -->
    <v-textarea
      v-else-if="dc.control == 'textarea'"
      :ref="dc.nombre"
      :label="labelCampo"
      :color="colorCampo"
      :rules="[validacionCampo]"
      :maxlength="dc.longitud"
      dense
      rows="2"
      auto-grow
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
    ></v-textarea>

    <!-- DATETIMEPICKER: campo de tipo fecha/hora  -->
    <SelectorFechaHora
      v-else-if="dc.control == 'date-picker' || dc.control == 'date-time-picker'"
      :ref="dc.nombre"
      :titulo-fecha="labelCampo"
      :obligatorio="dc.requerido"
      :hora="dc.control == 'date-time-picker'"
      titulo-hora=""
      formato-fecha="cccc, dd/MM/yyyy"
      formato-hora="HH:mm"
      literal-null="(Indefinido)"
      formato-modelo="sql"
      boton-borrar
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
      @change="$emit('change', $event, datosRegistro, definicionCampos)"
    />

    <!-- COMBOBOX (textfield con valores predeterminados) -->
    <v-combobox
      v-else-if="dc.control == 'combobox'"
      :ref="dc.nombre"
      :label="labelCampo"
      :color="colorCampo"
      :rules="[validacionCampo]"
      :items="itemsComboBox"
      :clearable="!dc.requerido && !$attrs.readonly"
      :value="descripcionValorComboBox()"
      dense
      v-bind="$attrs"
      @change="establecerValorCampoComboBox"
    ></v-combobox>

    <!-- ETIQUETA: para campos de solo lectura -->
    <template v-else-if="dc.control == 'div'">
      <div :class="[dc.clase_estilo]">
        {{ datosRegistro[dc.nombre] }}
      </div>
    </template>

    <!-- TEXTFIELD: campo de texto / contraseña  -->
    <v-text-field
      v-else
      :ref="dc.nombre"
      :label="labelCampo"
      :color="colorCampo"
      :rules="[validacionCampo, proxyFuncionValidacion]"
      :maxlength="dc.longitud"
      :type="tipoCampoTexto"
      :prepend-inner-icon="prependInnerIconCampo"
      :prefix="$attrs.prefix ? $attrs.prefix : (dc.prefijo_valor ? dc.prefijo_valor : '')"
      :suffix="$attrs.suffix ? $attrs.suffix : (dc.sufijo_valor ? dc.sufijo_valor : '')"
      dense
      v-model="datosRegistro[dc.nombre]"
      v-bind="$attrs"
      v-inputfilter="$attrs.inputfilter"
      @input="$emit('change', $event, datosRegistro, definicionCampos)"
    ></v-text-field>

  </span>
</template>

<script>
import SelectorFechaHora from '@/components/SelectorFechaHora.vue'

export default {
  components: { SelectorFechaHora },
  props: {
    nombreCampo: {
      type: String,
      required: true
    },
    definicionCampos: { // definicion de los campos
      type: Object,
      required: true
    },
    datosRegistro: { // datos del registro
      type: Object,
      required: true
    },
    funcionValidacion: {
      type: Function
    },
    funcionFiltradoItems: {
      type: Function
    }
  },
  data: () => ({
    itemsSelect: [],
    itemsComboBox: [],
  }),
  computed: {
    dc () {
      return this.definicionCampos [this.nombreCampo];
    },
    valorCampo () {
      return this.datosRegistro [this.nombreCampo];
    },
    labelCampo () {
      if (this.$attrs ['label'])
        return this.$attrs ['label'];
      else
        return this.dc.titulo;
    },
    colorCampo () {
      if (this.$attrs.readonly)
        return "silver";
      else if (this.$attrs ['color'])
        return this.$attrs ['color'];
      else
        return this.dc.color;
    },
    prependInnerIconCampo () {
      if (this.$attrs ['prepend-inner-icon'])
        return this.$attrs ['prepend-inner-icon'];
      else
        return this.dc.icono;
    },
    procedeMostrar() {
      if (this.dc.condicion_visibilidad_en_formulario) {
        return eval (this.dc.condicion_visibilidad_en_formulario);
      } else if (this.dc.visible_en_formulario !== undefined)
        return this.dc.visible_en_formulario;
      else
        return true;
    },
    itemsSelectFiltrado () {
      let array;
      if (this.funcionFiltradoItems) {
        array = this.itemsSelect.filter ((item) => {
          if (item)
            return this.funcionFiltradoItems (item, this.datosRegistro);
        })
      } else if (this.dc.filtro_items || this.dc.filtro_items_log) {
        array = this.itemsSelect.filter ((item) => {
          if (item) {
            return function() {
              try {
                if (this.dc.filtro_items_log)
                  console.log (eval (this.dc.filtro_items_log));
                return eval (this.dc.filtro_items);
              } catch (e) {
                console.error (e);
                return false;
              }
            }.call (this);
          }
        })
      } else {
        array = this.itemsSelect;
      }
      if (this.dc.seleccion_multiple && this.dc.seleccion_multiple.ordenar_lista_por_descripcion)
        array.sort ((a, b) => a.text.localeCompare (b.text, undefined, { sensitivity: "base" }));
      return array;
    },
    tipoCampoTexto () {
      if (this.dc.tipo_campo_texto)
        return this.dc.tipo_campo_texto;
      else if (this.dc.contrasena || this.dc.ocultar_valor)
        return 'password';
      else
        return 'text';
    }
  },
  watch: {
    itemsSelectFiltrado (arrayItems) {
      if (this.datosRegistro [this.dc.nombre] != null) {
        if (!this.dc.seleccion_multiple) {
          if (!arrayItems.some ( (item) => this.datosRegistro [this.dc.nombre] == item.value ))
            this.datosRegistro [this.dc.nombre] = null;
        } else if (this.dc.control != "lista-valores") {
          let arrayValores = this.datosRegistro [this.dc.nombre];
          for (var i = arrayValores.length-1; i >= 0; i--) {
            if (!arrayItems.some ( (item) => arrayValores[i] == item.value ))
              arrayValores.splice (i, 1);
          }
        }
      }
    },
    valorCampo: {
      handler (valor) {
        this.$emit('cambios', { campo: this.nombreCampo, valor: valor }, this.datosRegistro, this.definicionCampos);
        if (this.dc.evento_cambios) {
          let f = function () {
            return eval (this.dc.evento_cambios);
          };
          f.call (this);
        }
      },
      deep: true
    }
  },
  methods: {
    establecerValorCampoComboBox (valor) {
      if (Object (valor) === valor)
        this.datosRegistro [this.nombreCampo] = valor.value;
      else
        this.datosRegistro [this.nombreCampo] = valor;
    },
    descripcionValorComboBox () {
      let valor = this.datosRegistro [this.nombreCampo];
      let valorEnItemsComboBox = this.itemsComboBox.find ( (elemento) => elemento.value == valor );
      if (valorEnItemsComboBox)
        return valorEnItemsComboBox.text
      else
        return valor;
    },
    validacionCampo (valor) {
      if (this.dc.requerido)
        if (valor === undefined || valor === null)
          return false;

      if (this.procedeMostrar && this.dc.obligatorio) {
        if (valor === undefined || valor === null)
          return false;
        if (valor.length == 0) // this.dc.tipo.includes ('char') &&
          return false;
      }

      if (this.dc.contrasena)
        if (valor.length < 4)
          return false;

      return true;
    },
    proxyFuncionValidacion (valor) {
      if (this.funcionValidacion)
        return this.funcionValidacion (valor);
      else
        return true;
    },
    actualizarItemsSelect(){
      if (this.dc.dominio_valores) {
        this.itemsSelect = [];
        Object.entries (this.dc.dominio_valores).forEach(
          ([value, text]) => {
            let item = {};
            item.value = JSON.parse (value);
            item.text = text;
            if (this.dc.dominio_valores_extra) {
              let json = this.dc.dominio_valores_extra [value];
              if (json)
                item.extra = JSON.parse (json);
            }
            this.itemsSelect.push(item);
          }
        );
      } else if (this.dc.valores) {
        this.itemsComboBox = [];
        Object.entries (this.dc.valores).forEach(
          ([value, text]) => {
            let item = {};
            item.value = JSON.parse (value);
            item.text = text;
            if (this.dc.valores_extra) {
              let json = this.dc.valores_extra [value];
              if (json)
                item.extra = JSON.parse (json);
            }
            this.itemsComboBox.push(item);
          }
        );
      }
    },
    focus () {
      if (this.$children[0] != undefined)
        if (typeof this.$children[0].focus == "function")
          this.$children[0].focus();
    },
  },
  beforeMount (){
    if (this.dc.seleccion_multiple && !this.datosRegistro [this.nombreCampo]) {
      if (this.dc.control == 'lista-valores')
        this.datosRegistro [this.nombreCampo] = {};
      else
        this.datosRegistro [this.nombreCampo] = [];
    }

    if (!this.dc.actualizacion_manual_items)
      this.actualizarItemsSelect();

    this.$vnode.context.$refs[this.nombreCampo] = [];
    this.$vnode.context.$refs[this.nombreCampo][0] = this;
  },
  mounted(){
    this.$emit ('montado', this);
  }
}
</script>

<style>
</style>